
import { FootballRecord } from './types';

/**
 * Validates the time format in each record
 */
export const validateTimeFormat = (data: FootballRecord[]): FootballRecord[] => {
  if (!Array.isArray(data)) {
    console.error('Invalid data format received:', data);
    return [];
  }

  return data.map(row => ({
    ...row,
    Time: (!row.Time || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(String(row.Time))) ? '' : row.Time
  }));
};
